import React, { Component } from "react";
import { animateScroll } from "react-scroll";
import { FadeLoader } from "react-spinners";
import MessageItem from "./MessageItem";
import MessageInput from "./MessageInput";
import Firebase from "../../../firebasehelper";
import ErrorModal from "./ErrorModal";
import {
  getBetweenTimeoutValue,
  getTimeoutValue,
  getInputTimeoutValue,
} from "../../../Utils/botMessages";
import { registered_userMessages, userMessages } from "../constants/messages";
import "../../../Styles/MessageList.css";

const user_img = require("../../../assets/media/profile/avatar.png");

const override = `
  position: absolute;
  top: 48%;
  left: 48%;
  radius: 2px;
  height: 15px;
  width: 5px;
  display: block;
  margin: 0 auto;
  border-color: grey;
`;

class VerificationChat extends Component {
  constructor(props) {
    super(props);
    this.messages = [
      {
        type: "user",
        message: "Hello",
      },
    ];
    this.state = {
      showInput: false,
      messages: [],
      name: "",
      isIphoneX: true,
      brand: "ecosystem",
      uid: props.uid,
      profile: props.profile,
      is_member: false,
      already_existing: false,
      processing: false,
      botMessages: [],
      phoneNumber: "",
      avatars: [],
      userMessages: [],
    };
    this.errorButton = React.createRef();
    this.container = React.createRef();
  }

  initialize = () => {
    let botMessages = [];
    let userMessages = [...registered_userMessages];

    //bot Message initialize
    let firstMessage = [
      {
        type: "bot",
        message: `Please enter your cell phone number to link with your personal profile.`,
      },
    ];

    botMessages[0] = firstMessage;
    botMessages.push([
      {
        type: "bot",
        message: "Please confirm the sms code received.",
      },
    ]);

    this.setState(
      {
        name: "",
        isIphoneX: true,
        is_member: false,
        already_existing: false,
        processing: false,
        phoneNumber: "",
        messages: [],
        showInput: false,
        botMessages,
        userMessages,
        finished: false,
        phoneNumber: "",
        avatar_url: undefined,
        userMessage: undefined,
      },
      this.processBotMessageGroup
    );
  };

  componentDidUpdate(prevProps, prevStates, snapshot) {
    if (prevProps.modalNumber !== this.props.modalNumber) {
      this.initialize();
    }
  }
  componentDidMount() {
    const { brand_data } = this.props;
    const { name: brand_name } = brand_data;
    const loadBrandData = async () => {
      console.log("avatars###:", this.props);
      const data = await Firebase.getBrandDataByName(brand_name);
      console.log("avatars###:", data);
      if (data) {
        const { avatar1 = null, avatar2 = null } = data;
        const avatars = [avatar1, avatar2].map((item, index) => ({
          name: `avatar${index + 1}`,
          code: item,
          img: item || user_img,
          key: "avatar_url",
        }));

        console.log("avatars####:", avatars);

        this.setState({
          avatars,
        });
      }
    };
    loadBrandData();
    this.setState({ brand: brand_name });
  }

  /* message functions */
  getBotMessageGroup = () => {
    return this.state.botMessages.shift();
  };
  addBotMessageGroup = (msgGroup) => {
    return this.state.botMessages.unshift(msgGroup);
  };
  getRemainingMessages = () => {
    return this.state.botMessages.length;
  };
  addBotMessages = (messages) => {
    messages.map((item) => {
      return this.state.botMessages.push(item);
    });
  };
  getUserMessage = () => {
    return this.state.userMessages.shift();
  };
  addUserMessage = (message) => {
    this.state.userMessages.unshift(message);
  };
  addUserMessages = (messages) => {
    messages.map((item) => {
      return this.state.userMessages.push(item);
    });
  };
  processBotMessageGroup = () => {
    this.setState({
      showInput: false,
    });
    let messageGroup = this.getBotMessageGroup();
    console.log("here:", messageGroup);
    if (!messageGroup) {
      messageGroup = this.getBotMessageGroup();
    }
    if (messageGroup) {
      messageGroup.forEach((message, index) => {
        const timeoutValue =
          getTimeoutValue() + (index ? index * getBetweenTimeoutValue() : 0);
        setTimeout(() => {
          this.setMessageInState(message);
          this.scrollToBottom();
          if (index === messageGroup.length - 1) {
            this.toggleUserInput(true);
          }
        }, timeoutValue);
      });
    }
  };

  scrollToBottom = (delay = 0) => {
    if (delay) {
      setTimeout(() => {
        animateScroll.scrollToBottom({
          duration: 500,
          smooth: "easeInOutQuad",
          containerId: "verification-container",
        });
      }, delay);
    } else {
      animateScroll.scrollToBottom({
        duration: 500,
        smooth: "easeInOutQuad",
        containerId: "verification-container",
      });
    }
  };

  setMessages = () => {
    const { logo, icon } = this.props;
    const { messages } = this.state;
    return messages.map((message, i) => {
      const firstChild = i !== 0 && messages[i - 1].type !== message.type;
      return (
        <MessageItem
          firstChild={firstChild}
          key={i}
          timeoutValue={getTimeoutValue(message.message)}
          logo={logo}
          icon={icon}
          {...message}
        />
      );
    });
  };

  toggleUserInput = (timeout) => {
    if (!this.state.showInput) this.scrollToBottom(500);
    const { userMessage } = this.state;
    const showInput = !this.state.showInput;
    if (timeout) {
      console.log("here:", this.state);
      setTimeout(() => {
        if (!this.state.showInput) this.scrollToBottom(500);
        this.setState({
          showInput,
          userMessage: showInput ? this.getUserMessage() : userMessage,
        });
      }, getInputTimeoutValue());
    } else {
      this.setState({
        showInput,
        userMessage: showInput ? this.getUserMessage() : userMessage,
      });
    }
  };

  setMessageInState = (message) => {
    const messages = this.state.messages.slice();
    messages.push(message);
    this.setState({ messages });
  };
  addMessage = (message) => {
    console.log(
      "🚀 ~ file: VerificationChat.js:243 ~ VerificationChat ~ message:",
      message
    );
    if (message.key === "wrong_sms") {
      this.addUserMessage({
        type: "user",
        inputType: "input",
        placeholder: "6-digits",
        key: "sms",
      });
      this.addUserMessage({
        type: "user",
        inputType: "input",
        placeholder: "",
        key: "phone",
      });
      this.addBotMessageGroup([
        {
          type: "bot",
          message: "Please confirm the sms code received.",
        },
      ]);
      this.addBotMessageGroup([
        {
          type: "bot",
          message: `SMS Code is not matching. Try again.`,
        },
      ]);
      this.processBotMessageGroup();
    } else if (message.key === "no_received") {
      this.addUserMessage({
        type: "user",
        inputType: "input",
        placeholder: "6-digits",
        key: "sms",
      });
      this.addUserMessage({
        type: "user",
        inputType: "input",
        placeholder: "",
        key: "phone",
      });
      this.addBotMessageGroup([
        {
          type: "bot",
          message: "Please confirm the sms code received.",
        },
      ]);
      this.addBotMessageGroup([
        {
          type: "bot",
          message: `Try again.`,
        },
      ]);
      this.processBotMessageGroup();
    } else if (message.key === "sms") {
      let phone = message.phone;
      this.setState({ phoneNumber: phone });
      this.addBotMessageGroup([
        {
          type: "bot",
          message:
            "Congratulations! Your phone number is successfully verified.",
        },
        {
          type: "bot",
          message: "Now please select an avatar for your profile.",
        },
      ]);
      this.addUserMessage({
        type: "user",
        inputType: "avatar-choice",
        key: "avatar_url",
      });
      this.processBotMessageGroup();
    } else if (message.key === "phone" && message.inputType === "input") {
      this.addUserMessage({
        type: "user",
        inputType: "input",
        placeholder: "6-digits",
        key: "sms",
      });
      this.addBotMessageGroup([
        {
          type: "bot",
          message: "Please confirm the sms code received.",
        },
      ]);
      this.setMessageInState(message);
      this.processBotMessageGroup();
      return;
    } else if ((message.key = "avatar_url")) {
      console.log(
        "🚀 ~ file: VerificationChat.js:330 ~ VerificationChat ~ message:",
        message.ticketType.code
      );
      this.setState(
        { finished: true, avatar_url: message.ticketType.code },
        () => this.scrollToBottom()
      );
      return;
    } else {
      if (!message.finish) {
        setTimeout(() => {
          this.processBotMessageGroup();
        }, 1000);
      }
    }
    this.setMessageInState(message);
    this.toggleUserInput();
  };

  goBack = () => {
    this.processBotMessageGroup();
  };
  render = () => {
    const { logo, tier_data, uid, brand_data, smsSender, onSuccess } =
      this.props;
    const { territory } = brand_data;
    const {
      showInput,
      userMessage,
      isIphoneX,
      avatars,
      is_member,
      processing,
      finished,
      avatar_url,
      phoneNumber,
    } = this.state;
    console.log("here1:", this.state);
    return (
      <div
        className="message-list-wrapper"
        id="verification-container"
        style={{ minHeight: 0, height: "450px", overflow: "hidden" }}
      >
        {this.setMessages()}
        {!processing && (
          <div component="div" className="message-input-container">
            {showInput ? (
              <MessageInput
                message={userMessage}
                territory={territory}
                addMessage={this.addMessage}
                isIphoneX={isIphoneX}
                avatars={avatars}
                logo={logo}
                smsSender={smsSender}
                is_member={is_member}
                tier_data={tier_data}
                onRestart={this.goBack}
                uid={uid}
              />
            ) : null}
          </div>
        )}
        {processing && (
          <FadeLoader
            css={override}
            sizeUnit={"px"}
            size={100}
            loading={true}
          />
        )}
        {finished && (
          <button
            className="btn btn-green"
            style={{ marginLeft: "auto" }}
            onClick={() => {
              onSuccess(phoneNumber.replace(/\s/g, ""), avatar_url);
            }}
          >
            Start the next phase
          </button>
        )}
      </div>
    );
  };
}

export default VerificationChat;



// WEBPACK FOOTER //
// ./src/screens/Profile/components/VerificationChat.js